import {
  Directive,
  ElementRef,
  inject,
  input,
  OnInit,
  signal,
} from '@angular/core';

@Directive({
  selector: '[app-lazy-load]',
  host: {
    '[attr.src]': 'srcAttr()',
  },
})
export class LazyLoadDirective implements OnInit {
  private el = inject(ElementRef);

  readonly srcAttr = signal<string | null>(null);
  readonly src = input.required<string>();

  ngOnInit(): void {
    if (this.canLazyLoad()) {
      this.lazyLoadImage();
    } else {
      this.loadImage();
    }
  }

  private canLazyLoad() {
    return window && 'IntersectionObserver' in window;
  }

  private lazyLoadImage() {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(({ isIntersecting }) => {
        if (isIntersecting) {
          this.loadImage();
          obs.unobserve(this.el.nativeElement);
        }
      });
    });
    obs.observe(this.el.nativeElement);
  }

  private loadImage(): void {
    this.srcAttr.set(this.src());
  }
}
